"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapStateToProps = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _PulseAnnouncementMessage = _interopRequireDefault(require("../message/PulseAnnouncementMessage"));

var _IllustratedMessage = _interopRequireDefault(require("@react/react-spectrum/IllustratedMessage"));

require("./PulseAnnouncementsTab.scss");

var _reactRedux = require("react-redux");

var _AnnouncementReducer = require("../../store/reducers/AnnouncementReducer");

var _actions = require("../../store/actions/actions");

var _NoContent = _interopRequireDefault(require("../../resources/NoContent"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseAnnouncementsTab"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var NewAnnouncements = (0, _react.forwardRef)(function (props, ref) {
  var sectionHeader = props.sectionHeader,
      list = props.list,
      locale = props.locale;
  return _react.default.createElement("div", {
    className: "pulse-widget-new-announcements"
  }, _react.default.createElement("div", {
    className: "pulse-widget-announcements-list-section-header fixed-section-header",
    ref: ref
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: sectionHeader,
    description: "".concat(sectionHeader, " Subheading"),
    messageId: sectionHeader
  }), sectionHeader !== 'EARLIER' && list.length > 0 && " (".concat(list.length, ")")), _react.default.createElement("div", {
    className: "dummy-section-header"
  }), _react.default.createElement(AnnouncementsList, {
    list: list,
    locale: locale
  }));
});
NewAnnouncements.displayName = 'NewAnnouncements';
var EarlierAnnouncementsHeader = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement("div", {
    className: "pulse-widget-announcements-list-section-header announcement-earlier-section",
    ref: ref
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "EARLIER",
    description: "Earlier Subheading",
    messageId: "Earlier"
  }));
});
EarlierAnnouncementsHeader.displayName = 'EarlierAnnouncementsHeader';

var AnnouncementsList = function AnnouncementsList(props) {
  var list = props.list,
      locale = props.locale;
  return _react.default.createElement("ul", {
    className: "pulse-widget-announcements-list-style"
  }, list.map(function (announcement, key) {
    return _react.default.createElement("li", {
      key: key
    }, _react.default.createElement("div", {
      className: "pulse-widget-announcement-message-container"
    }, _react.default.createElement(_PulseAnnouncementMessage.default, {
      locale: locale,
      pulseMessageObject: announcement
    })));
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    announcementsList: (0, _AnnouncementReducer.getAnnouncements)(state),
    lastSeenTimeStamp: (0, _AnnouncementReducer.getLastAnnouncementSeenTimeStamp)(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchOnAnnouncementTabMount: function () {
      var _dispatchOnAnnouncementTabMount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch((0, _actions.onAnnouncementTabMount)());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function dispatchOnAnnouncementTabMount() {
        return _dispatchOnAnnouncementTabMount.apply(this, arguments);
      }

      return dispatchOnAnnouncementTabMount;
    }(),
    dispatchOnAnnouncementTabUnmount: function () {
      var _dispatchOnAnnouncementTabUnmount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch((0, _actions.onAnnouncementTabUnmount)());

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function dispatchOnAnnouncementTabUnmount() {
        return _dispatchOnAnnouncementTabUnmount.apply(this, arguments);
      }

      return dispatchOnAnnouncementTabUnmount;
    }()
  };
};

var PulseAnnouncementsTab = function PulseAnnouncementsTab(props) {
  var locale = props.locale,
      announcementsList = props.announcementsList,
      lastSeenTimeStamp = props.lastSeenTimeStamp,
      dispatchOnAnnouncementTabMount = props.dispatchOnAnnouncementTabMount,
      dispatchOnAnnouncementTabUnmount = props.dispatchOnAnnouncementTabUnmount;

  var _useState = (0, _react.useState)('NEW'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sectionHeader = _useState2[0],
      setSectionHeader = _useState2[1];

  var metrics = (0, _metrics.default)('exc.pulse.components.tabs.PulseAnnouncementsTab');
  var earlierSection = (0, _react.useRef)(null);
  var newSection = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    metrics.event('flyout.annoucements.renderAll', {
      region: window.config && window.config.region
    });
    dispatchOnAnnouncementTabMount();
    return function () {
      dispatchOnAnnouncementTabUnmount();
    };
  }, []);

  var handleScroll =
  /*#__PURE__*/
  function () {
    var _ref = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee3(e) {
      var topOffset, earlierPosition, newPosition;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              topOffset = e.target.scrollTop;
              earlierPosition = earlierSection.current && earlierSection.current.offsetTop;
              newPosition = newSection.current && newSection.current.offsetTop - newSection.current.clientHeight * 2.5;

              if (_PulseUtil.default.isEarlierSectionHeader(topOffset, earlierPosition, newPosition)) {
                setSectionHeader('EARLIER');
              } else {
                setSectionHeader('NEW');
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleScroll(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  if (!announcementsList) {
    return _react.default.createElement("div", {
      className: "pulse-announcements-tab-list"
    }, _react.default.createElement(_Wait.default, {
      centered: true
    }));
  }

  var announcements = _PulseUtil.default.filterAnnouncements(announcementsList, lastSeenTimeStamp);

  return _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localizationStrings
  }, _react.default.createElement("div", {
    className: "pulse-announcements-tab-list",
    onScroll: handleScroll
  }, announcementsList.length === 0 && _react.default.createElement("div", {
    className: "no-result-container"
  }, " ", _react.default.createElement(_IllustratedMessage.default, {
    className: "pulse-no-announcements-message",
    description: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
      defaultMessage: "You will receive information about scheduled maintenance activities and product issues being fixed",
      description: "No Announcements",
      messageId: "noAnnouncements"
    }),
    heading: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
      defaultMessage: "Your Announcements will appear here",
      description: "No Announcements title",
      messageId: "noAnnouncementsTitle"
    }),
    illustration: _react.default.createElement(_NoContent.default, null)
  })), announcementsList.length > 0 && _react.default.createElement("div", {
    className: "pulse-widget-announcements-tab-container"
  }, _react.default.createElement("div", {
    className: "pulse-widget-announcements-tab-list-container"
  }, announcements.new.length > 0 && _react.default.createElement(NewAnnouncements, {
    list: announcements.new,
    locale: locale,
    ref: newSection,
    sectionHeader: sectionHeader
  }), announcements.new.length > 0 && announcements.earlier.length > 0 && _react.default.createElement(EarlierAnnouncementsHeader, {
    ref: earlierSection
  }), announcements.earlier.length > 0 && _react.default.createElement(AnnouncementsList, {
    list: announcements.earlier,
    locale: locale
  })))));
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PulseAnnouncementsTab);

exports.default = _default;